import { Component } from '@angular/core';

@Component({
  selector: 'app-window-loader',
  templateUrl: './window-loader.component.html',
  styleUrl: './window-loader.component.css'
})
export class WindowLoaderComponent {

}
